import React from 'react'
import Footer from '../components/Footer'
import pry from '../img/priy.jpg'
import { Link } from 'react-router-dom'

const Priyanka = () => {
    return (
        <>

            <div className='heading'>
                <h2>Home / Dr. Priyanka</h2>
            </div>

            <section className="about-section">
                <div className="container">
                    <div className="row">

                        {/* Image Column */}
                        <div className="image-column col-lg-6 col-md-12 col-sm-12">
                            <div className="">

                                <figure className="image-1">
                                    <a href="#" className="lightbox-image" data-fancybox="images">
                                        <img
                                            title="Rahul Kumar Yadav"
                                            src={pry} />
                                    </a>
                                </figure>
                            </div>
                        </div>


                        {/* Content Column */}
                        <div className="content-column col-lg-6 col-md-12 col-sm-12 order-2">
                            <div className="inner-column">
                                <div className="sec-title">
                                    <span className="title">About  Doctor </span>
                                    <h2> Dr. Priyanka  pandey</h2>
                                    <h3>B.D.S. M.I.D.A </h3>
                                </div>
                                <div className="text" style={{ marginTop: '-30px' }}>
                                    I am a dental surgeon and have completed my BDS from Saraswati Dental College and Hospital Lucknow
                                    Presently working as Lecturer at Saraswati Dental College and Hospital  Lucknow
                                    All dental problems are diagnosed and treated with proper counseling and medication at my clinic
                                </div>

                                <div className="btn-box">
                                     <a href="#" className="theme-btn btn-style-three">Call Now   </a>
                                </div>
                            </div>
                        </div>



                    </div>
                </div>
            </section>


            <Footer />

        </>
    )
}

export default Priyanka